// Shopify owns consent storage and pixel permissions. No API secret is used here.
const words = JSON.parse(document.querySelector('[data-pp-privacy-text]')?.textContent || '{}');
const motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
let paused = motionQuery.matches;
try { paused ||= sessionStorage.getItem('projectpet.motion.paused') === '1'; } catch {}
function setMotion(value) {
  paused = value;
  document.documentElement.dataset.ppMotionPaused = String(paused);
  document.querySelectorAll('[data-pp-motion-toggle]').forEach(button => {
    button.textContent = paused ? words.resume : words.pause;
    button.setAttribute('aria-pressed', String(paused));
  });
  if (paused) document.querySelectorAll('.pp video').forEach(video => video.pause());
  document.dispatchEvent(new CustomEvent('projectpet:motion-change', { detail: { paused } }));
}
setMotion(paused);
motionQuery.addEventListener('change', event => setMotion(event.matches));
document.addEventListener('shopify:section:load', () => setMotion(paused));
document.addEventListener('click', async event => {
  const button = event.target.closest('[data-pp-cookie-preferences],[data-pp-motion-toggle]');
  if (!button) return;
  if (button.matches('[data-pp-motion-toggle]')) {
    setMotion(!paused);
    try { sessionStorage.setItem('projectpet.motion.paused', paused ? '1' : '0'); } catch {}
    return;
  }
  button.disabled = true;
  try {
    if (!window.privacyBanner?.showPreferences) throw new Error('Privacy banner unavailable');
    await window.privacyBanner.showPreferences();
  } catch {
    let status = document.querySelector('[data-pp-privacy-status]');
    if (!status) { status = document.createElement('p'); status.dataset.ppPrivacyStatus = ''; status.setAttribute('role','status'); button.after(status); }
    status.textContent = words.unavailable;
  } finally { button.disabled = false; }
});
// Deter casual saving only; public media cannot be made download-proof.
document.addEventListener('contextmenu', event => {
  if (event.target.closest('.pp img,.pp video')) event.preventDefault();
});
document.addEventListener('dragstart', event => {
  if (event.target.closest('.pp img')) event.preventDefault();
});
